const URL_STAGING_IDENTITY = "https://id.stg.internal.atlassian.com";
const URL_PRODUCTION_IDENTITY = "https://id.atlassian.com";

const URL_STAGING_WAC = "https://wac.stg.internal.atlassian.com";
const URL_PRODUCTION_WAC = "https://www.atlassian.com";

const URL_STAGING_API = "https://wac.stg.internal.atlassian.com/gateway/api";
const URL_PRODUCTION_API = "https://www.atlassian.com/gateway/api";

export const CONTENTFUL_GRAPHQL_API_URL =
    typeof window !== "undefined"
        ? // @ts-ignore - Client side
          `${window.CONTENTFUL_BASE_URL_GQL}/content/v1/spaces/${window.CONTENTFUL_SPACE_ID_PRODUCT_TEMPLATES}/environments/${window.CONTENTFUL_ENVIRONMENT_PRODUCT_TEMPLATES}`
        : // Server side
          `${process.env["CONTENTFUL_BASE_URL_GQL"]}/content/v1/spaces/${process.env["CONTENTFUL_SPACE_ID_PRODUCT_TEMPLATES"]}/environments/${process.env["CONTENTFUL_ENVIRONMENT_PRODUCT_TEMPLATES"]}`;

export const isProduction = () =>
    // assume production when environment is unknown
    !["dev", "development", "staging"].includes(
        String(process.env["NODE_ENV"])
    );

export const getIdentityBaseUrl = () =>
    isProduction() ? URL_PRODUCTION_IDENTITY : URL_STAGING_IDENTITY;

export const getWacIntegrationUrl = () =>
    isProduction() ? URL_PRODUCTION_WAC : URL_STAGING_WAC;

export const getApiBaseUrl = () =>
    isProduction() ? URL_PRODUCTION_API : URL_STAGING_API;

export const identityBaseUrl = getIdentityBaseUrl();
export const integrationUrl = getWacIntegrationUrl();

export type Bundle =
    | "jira-software"
    | "confluence"
    | "jira-service-management"
    | "jira-service-management-jira-software";

/**
 * Returns product name
 *
 * @param bundleParam {string} - product bundle
 *
 * @returns product name or undefined
 */
export const getProductNameFromBundle = (
    bundleParam?: string,
    productParam?: string
): string => {
    if (productParam) {
        bundleParam = getBundleFromProductParam(productParam);
    }

    switch (bundleParam) {
        case "confluence":
            return "Confluence";
        case "jira-service-management":
            return "Jira Service Management";
        case "jira-service-management-jira-software":
            return "Jira Service Management + Jira";
        case "compass":
            return "Compass";
        case "jira-product-discovery":
            return "Jira Product Discovery";
        case "loom":
            return "Loom";
        case "bitbucket":
            return "Bitbucket";
        case "jira-software":
        case "":
            return "Jira";
        default:
            return "";
    }
};

/**
 * Returns product bundle name
 *
 * @param productParam {string} - product name
 *
 * @returns product bundle name
 */
export const getBundleFromProductParam = (productParam: string) => {
    switch (productParam) {
        case "jira-software.ondemand":
        case "":
            return "jira-software";
        case "jira-servicedesk.ondemand":
            return "jira-service-management";
        case "confluence.ondemand":
            return "confluence";
        case "jira-product-discovery":
            return "jira-product-discovery";
        case "jira-servicedesk.ondemand,jira-software.ondemand":
            return "jira-service-management-jira-software";
        case "compass.ondemand":
            return "compass";
        case "com.atlassian.bitbucket.manual":
            return "bitbucket";
        default:
            return "";
    }
};
